module.exports = __webpack_public_path__ + "static_assets/img/infolayer_default.5c0e589.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/infolayer_default.png
// module id = c4xf
// module chunks = 40